import * as ng from 'angular';
import { OrganismOverviewController, OverviewDataObject } from '../../../../organisms/overview/overview';

export class MoleculeOverviewRowPanelSslCertificateController implements ng.IController {
    public static $inject: string[] = [];

    public overviewData: OverviewDataObject;
    public overviewLoad: (selection: any) => any;
    public internalPaginationLimit: number;
    public OrganismOverview: OrganismOverviewController;

    public get showAccounts() {
        return this.OrganismOverview.globals.showAccounts;
    }
}

export class MoleculeOverviewRowPanelSslCertificateComponent implements ng.IComponentOptions {
    public require = {
        OrganismOverview: '^organismOverview'
    };
    public bindings = {
        internalPaginationLimit: '<',
        overviewData: '<',
        overviewLoad: '<'
    };
    public controller =  MoleculeOverviewRowPanelSslCertificateController;
    public controllerAs = 'OverviewSslCertificateCtrl';
    public template = require('./ssl-certificate-row.html');
}
